import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SearchIcon from '@mui/icons-material/Search';
import SecurityIcon from '@mui/icons-material/Security';
import SettingsIcon from '@mui/icons-material/Settings';
import {
    Box,
    CardContent,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    useMediaQuery,
} from '@mui/material';
import type { GetStaticProps, NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement, ReactNode } from 'react';

import {
    Body,
    ListItemStyle,
    NestedListItem,
    StyleCard,
    StyledContactFooter,
} from '@/src/modules/NewsLetter/newsLetterPage.style';
import { appVersion } from '@/src/shared/constants/CommonConstants';
import { defaultlayout } from '@/src/shared/constants/layoutConstant';
import { tabScreen } from '@/src/shared/constants/MediaQueryConstants';
import { withMsalAuthentication } from '@/src/shared/hocs/withMsalAuthentication';
import { primaryOrange } from '@/src/styles/theme/lightThemeOptions';
import { getBlobUrl } from '@/src/utils/commonUtil';

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
    getLayout?: (page: ReactElement) => ReactNode;
    layout?: string;
};

const Newsletter: NextPageWithLayout = withMsalAuthentication(() => {
    const isTabScreen = useMediaQuery(tabScreen);
    return (
        <Box mb={4}>
            <StyleCard>
                <CardContent>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container>
                            <Grid item xs={12} mt={24}>
                                <Typography
                                    fontFamily={'Equip_Regular'}
                                    fontSize={'9px !important'}
                                    color={'#485155'}
                                    position={'relative'}
                                    textAlign={'right'}
                                    top={-75}
                                >
                                    21 Sep. 2026 <span style={{ color: primaryOrange }}> | </span>
                                    <span>V </span>
                                    {appVersion}
                                </Typography>
                                <Grid
                                    container
                                    className="grid-bg--image"
                                    wrap={isTabScreen ? 'nowrap' : 'wrap'}
                                    alignItems="center"
                                >
                                    <Grid item xs={12} md={4} lg={3} position="relative">
                                        <img
                                            src={getBlobUrl('agnesNewsBannerIcon')}
                                            alt={'agnesNewsBannerIcon'}
                                            height={'auto'}
                                            className="main-banner-img"
                                            loading="lazy"
                                        />
                                        {/* <AgnesTalk>
                                            <Typography
                                                fontFamily={'Equip_Regular'}
                                                className="agnes-text"
                                            >
                                                Ich bin&#39;s,
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                className="agnes-logo-text"
                                                fontFamily={'Equip_Bold'}
                                                color="#FBE4D3"
                                                lineHeight={1}
                                            >
                                                AGNES
                                            </Typography>
                                            <Typography
                                                fontFamily={'Equip_Regular'}
                                                className="agnes-text"
                                            >
                                                deine neue Arbeitsbegleiterin!
                                            </Typography>
                                        </AgnesTalk> */}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={8}
                                        lg={8}
                                        pr={{ lg: 32, md: 16 }}
                                        m="auto"
                                        className="list-container"
                                    >
                                        <Typography
                                            variant="body1"
                                            component="div"
                                            fontFamily={'Equip_Bold'}
                                            fontSize={'24px'}
                                            textAlign={'center'}
                                            fontWeight={800}
                                            m="auto"
                                            className="list-container-heading"
                                        >
                                            Ich bin jung, anpassungsfähig und bin hier, um dein
                                            Leben noch fantastischer zu machen! Ich bin 24/7 für
                                            dich da!
                                        </Typography>
                                        <Box
                                            display={'flex'}
                                            flexDirection="row"
                                            justifyContent={'space-between'}
                                            mt={5}
                                            className="list-container-itmes"
                                        >
                                            <ListItemStyle pr={8}>
                                                <Typography
                                                    variant="body1"
                                                    component="div"
                                                    fontFamily={'Equip_Bold'}
                                                    mt={{ md: 0, xs: 4, lg: 0 }}
                                                >
                                                    Meine Fähigkeiten umfassen eine Vielzahl von
                                                    Fertigkeiten, wie zum Beispiel:
                                                </Typography>
                                                <List>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <CalendarMonthIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Anleitung zur" />
                                                    </ListItem>
                                                    <List disablePadding className="nested-lists">
                                                        <NestedListItem>
                                                            <Image
                                                                src={getBlobUrl('graterArrowIcon')}
                                                                alt={'graterArrowIcon'}
                                                                height={8}
                                                                width={16}
                                                            />
                                                            <ListItemText primary="Arbeitszeitmanagement," />
                                                        </NestedListItem>
                                                        <NestedListItem>
                                                            <Image
                                                                src={getBlobUrl('graterArrowIcon')}
                                                                alt={'graterArrowIcon'}
                                                                height={8}
                                                                width={16}
                                                            />
                                                            <ListItemText primary="Urlaubsregelungen und" />
                                                        </NestedListItem>
                                                        <NestedListItem>
                                                            <Image
                                                                src={getBlobUrl('graterArrowIcon')}
                                                                alt={'graterArrowIcon'}
                                                                height={8}
                                                                width={16}
                                                            />
                                                            <ListItemText primary="Home office" />
                                                        </NestedListItem>
                                                    </List>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <SecurityIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Informationen zur Cybersecurity" />
                                                    </ListItem>
                                                    <List disablePadding>
                                                        <ListItem>
                                                            <ListItemIcon>
                                                                <LocationOnIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Suche nach Experten" />
                                                        </ListItem>
                                                    </List>
                                                    <List disablePadding>
                                                        <ListItem>
                                                            <ListItemIcon>
                                                                <LightbulbIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Informationen zu allen hinterlegten Dokumenten" />
                                                        </ListItem>
                                                    </List>
                                                </List>
                                            </ListItemStyle>
                                            <ListItemStyle>
                                                <Typography
                                                    variant="body1"
                                                    component="div"
                                                    fontFamily={'Equip_Bold'}
                                                    mt={{ md: 0, xs: 8, lg: 0 }}
                                                >
                                                    Hier ein kleiner Ausblick auf das, was uns in
                                                    Zukunft erwartet:
                                                </Typography>
                                                <List>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <SettingsIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Integration von mehr interaktiven Funktionen, wie" />
                                                    </ListItem>
                                                    <List disablePadding className="nested-lists">
                                                        <NestedListItem>
                                                            <Image
                                                                src={getBlobUrl('graterArrowIcon')}
                                                                alt={'graterArrowIcon'}
                                                                height={8}
                                                                width={16}
                                                            />
                                                            <ListItemText primary="Erstellung eines IT-Support-Tickets," />
                                                        </NestedListItem>
                                                        <NestedListItem>
                                                            <Image
                                                                src={getBlobUrl('graterArrowIcon')}
                                                                alt={'graterArrowIcon'}
                                                                height={8}
                                                                width={16}
                                                            />
                                                            <ListItemText primary="Bestellung von IT-Diensten Produkten" />
                                                        </NestedListItem>
                                                    </List>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <SearchIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Verbesserte Lernfunktionen zu Unterstützung bei neuen Themen" />
                                                    </ListItem>
                                                    <ListItem>
                                                        <ListItemIcon>
                                                            <img
                                                                src={getBlobUrl('sabioIcon')}
                                                                alt={'sabioIcon'}
                                                                height={12}
                                                                width={12}
                                                                loading="lazy"
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Integration und Erweiterung meines Wissens aus Sabio" />
                                                    </ListItem>
                                                </List>
                                            </ListItemStyle>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <StyledContactFooter>
                            <Typography
                                variant="body2"
                                component="div"
                                textAlign={'left'}
                                m="auto"
                                className="contact-us-left"
                            >
                                Gibt es etwas, das wir noch besser machen könnten? Sende uns
                                jederzeit eine Nachricht an &nbsp;
                                <Link
                                    href="mailto:agnes@asfinag.at"
                                    style={{ textDecoration: 'none', color: primaryOrange }}
                                >
                                    agnes@asfinag.at
                                </Link>
                                &nbsp; mit deinen Ideen und Vorschlägen.
                            </Typography>
                            <Body className="contact-us-center">
                                <Box position="relative" width={430} height={295} m={'auto'}>
                                    <Box className="contact-us-center-img">
                                        <img
                                            src={getBlobUrl('agnesBubbleTalks')}
                                            alt={'agnesBubbleTalks'}
                                            loading="lazy"
                                            className="contact-us-img"
                                        />
                                    </Box>
                                </Box>
                            </Body>
                            <Typography
                                variant="body2"
                                component="div"
                                textAlign={'left'}
                                m="auto"
                                width=" 100%"
                                className="contact-us-right"
                            >
                                Ein Wort der Vorsicht: deine Daten sind bei mir zwar sicher, aber
                                ich empfehle dir trotzdem keine persönlichen oder sensiblen Daten in
                                unserem Chat einzugeben.
                            </Typography>
                        </StyledContactFooter>
                    </Box>
                </CardContent>
            </StyleCard>
        </Box>
    );
});

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale ?? 'en', ['common'])),
        },
    };
};

Newsletter.layout = defaultlayout;
export default Newsletter;
